const salt = "1kshf189sdfk1";

const cipherCreator = salt => {
  const textToChars = text => text.split("").map(c => c.charCodeAt(0));
  const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
  const applySaltToChar = code =>
    textToChars(salt).reduce((a, b) => a ^ b, code);

  return text =>
    text.split("").map(textToChars).map(applySaltToChar).map(byteHex).join("");
};

const decipherCreator = salt => {
  const textToChars = text => text.split("").map(c => c.charCodeAt(0));
  const applySaltToChar = code =>
    textToChars(salt).reduce((a, b) => a ^ b, code);
  return encoded =>
    encoded
      .match(/.{1,2}/g)
      .map(hex => parseInt(hex, 16))
      .map(applySaltToChar)
      .map(charCode => String.fromCharCode(charCode))
      .join("");
};

export function cipher(str: string): string {
  return cipherCreator(salt)(str);
}

export function decipher(str: string): string {
  return decipherCreator(salt)(str);
}
